/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
export const selectPasswordPolicies = (state: { passwordPolicies: any }) => state.passwordPolicies?.entities;
export const selectPasswordPoliciesLoading = (state: { passwordPolicies: any }) => state.passwordPolicies?.isLoading;
export const selectPasswordPoliciesError = (state: { passwordPolicies: any }) => state.passwordPolicies?.error;
export const selectPasswordPolicyDetails = (state: { passwordPolicies: any }, passwordPolicyId: string) =>
  state.passwordPolicies?.detailsById[passwordPolicyId]?.policyDetails;
export const selectPasswordPolicyDetailsLoading = (state: { passwordPolicies: any }, passwordPolicyId: string) =>
  state.passwordPolicies?.detailsById[passwordPolicyId]?.isLoading ?? true;
export const selectPasswordPolicyDetailsError = (state: { passwordPolicies: any }, passwordPolicyId: string) =>
  state.passwordPolicies?.detailsById[passwordPolicyId]?.error;
export const selectFormValues = (state: { passwordPolicies: any; }) => state.passwordPolicies?.formValues;